import LearningResultExporter from './LearningResultExporter';

export default LearningResultExporter;
